import React, { useRef, useState, useMemo, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import {
  // Avatar as MuiAvatar,
  Badge,
  Box,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Popover as MuiPopover,
  Tooltip,
  Typography,
} from "@material-ui/core";

import { Bell } from "react-feather";
//import { unicodeIcons } from "../pages/dashboards/UnicodeIcons";
import { getNotificationsService } from "../services/userService";
import { connectionManager } from "../pages/dashboards/connectionManager";
import store from "../redux/store";
import { wrapEmoji } from "../pages/dashboards/UnicodeIcons";
import Checklist from "../pages/checklist/checklist";

const Popover = styled(MuiPopover)`
  .MuiPaper-root {
    width: 300px;
    ${(props) => props.theme.shadows[1]};
    border: 1px solid ${(props) => props.theme.palette.divider};
  }
`;

const Indicator = styled(Badge)`
  .MuiBadge-badge {
    background: ${(props) => props.theme.header.indicator.background};
    color: ${(props) => props.theme.palette.common.white};
  }
`;

// const Avatar = styled(MuiAvatar)`
//   background: ${(props) => props.theme.palette.primary.main};
// `;

const NotificationHeader = styled(Box)`
  text-align: center;
  border-bottom: 1px solid ${(props) => props.theme.palette.divider};
`;

function Notification({ title, description, Icon, onClick }) {
  const iconContainerStyle = {
    width: `${36}px`,
    height: `${36}px`,
    borderRadius: '50%',
    textAlign: 'center',
    lineHeight: `${36}px`,
    fontSize: `${24}px`
  };

  const renderedIcon = useMemo(() => {
    if (typeof Icon === 'function')
      return Icon;

    return wrapEmoji(Icon);
  }, [Icon]);

  return (
    <ListItem divider component={Link} to="#" onClick={onClick}>
      <ListItemAvatar>
        <div style={iconContainerStyle}>
          {renderedIcon({})}
        </div>
      </ListItemAvatar>
      <ListItemText
        primary={title}
        primaryTypographyProps={{
          variant: "subtitle2",
          color: "textPrimary",
        }}
        secondary={description}
      />
    </ListItem>
  );
}

function NotificationsDropdown() {
  const ref = useRef(null);
  const [isOpen, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  
  const [
    notifications,
    setNotifications
  ] = useState([]);

  // const [
  //   lastNotificationId,
  //   setLastNotificationId
  // ] = useState(0);
  
  const lastNotificationId = useMemo(() => {
    return notifications[notifications.length-1]?.id ?? 0;
  }, [notifications]);

  const lastRequestId = useRef(0);  

  useEffect(() => {
    const requestId = ++lastRequestId.current;
    const before = lastNotificationId;
    getNotificationsService(before)
    .then((response) => {
      if (response.status >= 400)
        throw new Error('HTTP error ' + response.status);

      const newNotifications = response.data;
      if (lastRequestId.current === requestId) {
        setNotifications((prevNotification) => {
          const newList = before
            ? prevNotification.concat(newNotifications) 
            : newNotifications;
          return newList;
        });
      }
    });
  // eslint-disable-next-line no-use-before-define
  }, [lastNotificationId]);


  useEffect(() => {
    const state = store.getState();
    const user = state.authReducer.user;
    connectionManager
      .init(user.profile.shortToken, user.profile)
      .then(() => {
        // Register the LiveTemperature event listener using the manager
        connectionManager.on("Notification", (message) => {
          try {
            setNotifications([]);
          } catch (error) {
            console.error("Error parsing LiveTemperature message", error);
          }
        });
      });
    
    return () => {
      connectionManager.off('Notification');
    };
  }, []);

  const newCount = useMemo(() => {
    return notifications?.filter((notification) => {
      return !notification.readAt;
    })?.length ?? 0;
  }, [notifications]);

  const notificationTitle = useMemo(() => {
    return <span>
      {newCount} Notifications
    </span>
  }, [newCount]);

  const handleNotificationClick = useCallback((notification, event) => {
    console.log('Clicked', notification);
    window.location.href = "/checklists?openchecklist=" + notification.checklistId;
  }, []);

  const renderedNotifications = useMemo(() => {
    return notifications?.map((notification) => {
      return <Notification
        key={notification.id}
        title={notification.title}
        description={notification.message}
        Icon={notification.icon}
        onClick={(event) => handleNotificationClick(notification, event)}
      />;
    }) ?? [];
  }, [handleNotificationClick, notifications]);

  return (
    <React.Fragment>
      <Tooltip title="Notifications">
        <IconButton color="inherit" ref={ref} onClick={handleOpen}>
          <Indicator badgeContent={notifications?.length}>
            <Bell />
          </Indicator>
        </IconButton>
      </Tooltip>
      <Popover
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
      >
        <NotificationHeader p={2}>
          <Typography variant="subtitle1" color="textPrimary">
            {notificationTitle}
          </Typography>
        </NotificationHeader>
        <React.Fragment>
          <List disablePadding>
            {renderedNotifications}
            {/* <Notification
              title="Checklist Pending"
              description="Check pizza temperature"
              Icon={unicodeIcons.pizza}
            />
            <Notification
              title="Checklist Pending"
              description="Check chicken temperature"
              Icon={unicodeIcons.chicken}
            />
            <Notification
              title="Alarm"
              description="Freezer reached 36°C at 01:42:23"
              Icon={unicodeIcons.alarm}
            />
            <Notification
              title="Error"
              description="This is for some hypothetical error"
              Icon={unicodeIcons.cautionMark}
            /> */}
          </List>
          <Box p={1} display="flex" justifyContent="center">
            <Button size="small" component={Link} to="#">
              Show all notifications
            </Button>
          </Box>
        </React.Fragment>
      </Popover>
    </React.Fragment>
  );
}

//user: state.authReducer.user,

export default NotificationsDropdown;
